(function () {
  "use strict";

  function safeParseConfig() {
    if (!window.sessionTrackerConfig || typeof window.sessionTrackerConfig !== "object") {
      return null;
    }
    return window.sessionTrackerConfig;
  }

  function getSessionId() {
    var key = "shopify_optimizer_session_id";
    try {
      var existing = localStorage.getItem(key);
      if (existing) return existing;
      var next = "sess_" + Date.now() + "_" + Math.random().toString(36).slice(2, 10);
      localStorage.setItem(key, next);
      return next;
    } catch (e) {
      return "sess_" + Date.now() + "_no_storage";
    }
  }

  function getAttribution() {
    try {
      var p = new URLSearchParams(window.location.search);
      var utmSource = p.get("utm_source");
      var referrerSource = document.referrer ? "referrer" : "(direct)";
      return {
        source: utmSource || referrerSource,
        medium: p.get("utm_medium") || "(none)",
        campaign: p.get("utm_campaign") || "",
      };
    } catch (e) {
      return { source: "(unknown)", medium: "(unknown)", campaign: "" };
    }
  }

  function postEvent(endpoint, payload) {
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: "application/json" });
        if (navigator.sendBeacon(endpoint, blob)) return;
      }
    } catch (e) {
      // Fall through to fetch.
    }
    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body,
      keepalive: true,
      mode: "cors",
      credentials: "omit",
    }).catch(function () {});
  }

  function sendClarityTag(key, value) {
    if (!window.clarity || !key) return;
    var str = value == null ? "" : String(value);
    if (!str) return;
    try {
      window.clarity("set", key, str);
    } catch (e) {
      // Ignore tracking errors.
    }
  }

  function sendClarityEvent(name) {
    if (!window.clarity || !name) return;
    try {
      window.clarity("event", name);
    } catch (e) {
      // Ignore tracking errors.
    }
  }

  function sendGoogleAnalyticsEvent(name, payload) {
    if (!name || name !== "product_cta_click") return;
    var params = {
      page_type: payload.page_type || "",
      page_location: payload.page_url || window.location.href,
      target_href: payload.target_href || "",
      target_label: payload.target_label || "",
      interaction_type: payload.interaction_type || "",
      source: payload.source || "",
      medium: payload.medium || "",
      campaign: payload.campaign || "",
      product_handle: payload.product_handle || "",
    };
    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", name, params);
        return;
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params));
    } catch (e) {
      // Ignore analytics bridge errors.
    }
  }

  function buildPayload(base, eventName, productId, variantId, extra) {
    var attr = getAttribution();
    var payload = {
      timestamp: new Date().toISOString(),
      event_name: eventName,
      product_id: productId ? String(productId) : "",
      variant_id: variantId ? String(variantId) : "",
      session_id: base.sessionId,
      source: attr.source,
      medium: attr.medium,
      campaign: attr.campaign,
      page_type: base.pageType || "",
      customer_id: base.customerId ? String(base.customerId) : "",
      shop: base.shop || "",
      page_url: window.location.href,
    };
    if (extra && typeof extra === "object") {
      Object.keys(extra).forEach(function (key) {
        var value = extra[key];
        if (value == null) return;
        payload[key] = typeof value === "string" ? value.slice(0, 160) : value;
      });
    }
    return payload;
  }

  function mirrorToClarity(base, payload) {
    if (!base.clarityEnabled || !window.clarity) return;
    sendClarityTag("shop", base.shop || "");
    sendClarityTag("page_type", base.pageType || "");
    sendClarityTag("session_id", base.sessionId || "");
    sendClarityTag("source", payload.source || "");
    sendClarityTag("medium", payload.medium || "");
    sendClarityTag("campaign", payload.campaign || "");
    sendClarityTag("product_id", payload.product_id || "");
    sendClarityTag("variant_id", payload.variant_id || "");
    sendClarityTag("customer_id", payload.customer_id || "");
    sendClarityTag("interaction_type", payload.interaction_type || "");
    sendClarityTag("target_role", payload.target_role || "");
    sendClarityEvent(payload.event_name);
  }

  function sendEvent(base, eventName, extra) {
    var payload = buildPayload(base, eventName, extra && extra.product_id, extra && extra.variant_id, extra);
    if (base.collectorEnabled) postEvent(base.endpoint, payload);
    mirrorToClarity(base, payload);
    sendGoogleAnalyticsEvent(eventName, payload);
  }

  function fetchCartSnapshot(timeoutMs) {
    var controller = window.AbortController ? new AbortController() : null;
    var timeout = null;
    if (controller) {
      timeout = window.setTimeout(function () {
        controller.abort();
      }, timeoutMs || 700);
    }

    return fetch("/cart.js", {
      method: "GET",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      signal: controller ? controller.signal : undefined,
    })
      .then(function (response) {
        if (!response.ok) throw new Error("cart_fetch_failed");
        return response.json();
      })
      .finally(function () {
        if (timeout) window.clearTimeout(timeout);
      });
  }

  function sendBeginCheckoutEvents(base) {
    return fetchCartSnapshot(700)
      .then(function (cart) {
        var items = cart && Array.isArray(cart.items) ? cart.items : [];
        if (!items.length) {
          sendEvent(base, "begin_checkout", { product_id: base.pageProductId });
          return;
        }

        items.forEach(function (item) {
          sendEvent(base, "begin_checkout", {
            product_id: item.product_id,
            variant_id: item.variant_id || item.id,
            product_title: item.product_title || item.title || "",
            quantity: item.quantity || 1,
            cart_item_count: items.length,
            cart_total_price: cart.total_price || "",
          });
        });
      })
      .catch(function () {
        sendEvent(base, "begin_checkout", { product_id: base.pageProductId });
      });
  }

  function continueCheckout(el) {
    var form = el && el.closest ? el.closest("form") : null;
    if (el && el.tagName && el.tagName.toLowerCase() === "a") {
      var href = el.getAttribute("href");
      if (href) window.location.href = href;
      return;
    }
    if (form) {
      if (form.requestSubmit) {
        form.requestSubmit(el);
      } else {
        form.submit();
      }
    }
  }

  function cleanText(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 80);
  }

  function getElementRole(el) {
    if (!el) return "";
    if (el.matches("button,input[type='submit'],input[type='button']")) return "button";
    if (el.matches("a")) return "link";
    if (el.matches("summary")) return "summary";
    if (el.matches("input,select,textarea")) return "field";
    return (el.tagName || "").toLowerCase();
  }

  function getTargetPayload(el, event, interactionType) {
    var href = el && el.getAttribute ? el.getAttribute("href") || "" : "";
    var taggedEl =
      el && el.closest
        ? el.closest("[data-plan-name],[data-plan-action],[data-plan-location],[data-plan-tab]")
        : null;
    var label = cleanText(
      (el && (el.getAttribute("aria-label") || el.getAttribute("data-track-label") || el.textContent || el.value)) || ""
    );
    var rect = el && el.getBoundingClientRect ? el.getBoundingClientRect() : null;
    var x = event && typeof event.clientX === "number" ? event.clientX : null;
    var y = event && typeof event.clientY === "number" ? event.clientY : null;
    return {
      interaction_type: interactionType,
      target_role: getElementRole(el),
      target_label: label,
      target_href: href ? href.slice(0, 160) : "",
      viewport_width: window.innerWidth || 0,
      viewport_height: window.innerHeight || 0,
      scroll_y: Math.round(window.scrollY || 0),
      click_x_pct: x == null || !window.innerWidth ? "" : Math.round((x / window.innerWidth) * 1000) / 10,
      click_y_pct: y == null || !window.innerHeight ? "" : Math.round((y / window.innerHeight) * 1000) / 10,
      target_top: rect ? Math.round(rect.top + (window.scrollY || 0)) : "",
      plan_name: taggedEl ? taggedEl.getAttribute("data-plan-name") || "" : "",
      plan_action: taggedEl ? taggedEl.getAttribute("data-plan-action") || "" : "",
      plan_location: taggedEl ? taggedEl.getAttribute("data-plan-location") || "" : "",
      plan_tab: taggedEl ? taggedEl.getAttribute("data-plan-tab") || "" : "",
    };
  }

  function getProductHandleFromHref(href) {
    if (!href) return "";
    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : "";
    } catch (e) {
      var fallback = String(href).match(/\/products\/([^/?#]+)/);
      return fallback ? decodeURIComponent(fallback[1]) : "";
    }
  }

  function isMeaningfulTarget(el) {
    if (!el || !el.matches) return false;
    return !!el.closest('a,button,input,select,textarea,summary,[role="button"],[data-track-click]');
  }

  function installInteractionTracking(base) {
    var recentClicks = [];
    var lastTouchAt = 0;

    document.addEventListener(
      "click",
      function (e) {
        var target = e.target && e.target.closest ? e.target.closest('a,button,input,select,textarea,summary,[role="button"],[data-track-click]') : null;
        var meaningful = isMeaningfulTarget(e.target);
        var payload = getTargetPayload(target || e.target, e, "click");
        var followsTouch = Date.now() - lastTouchAt < 700;

        if (meaningful && !followsTouch) {
          sendEvent(base, "interaction_click", payload);
        } else if (!meaningful) {
          sendEvent(base, "dead_click", payload);
        }

        if (target && target.closest('a[href*="/pages/ypb-consult"],a[href*="/pages/contact"],a[href="#builders-contact"],form[action*="/contact"],#ContactForm')) {
          sendEvent(base, "contact_intent", payload);
        }

        recentClicks.push({
          t: Date.now(),
          x: e.clientX,
          y: e.clientY,
        });
        recentClicks = recentClicks.filter(function (click) {
          return Date.now() - click.t < 1800;
        });
        if (recentClicks.length >= 3) {
          var first = recentClicks[0];
          var clustered = recentClicks.every(function (click) {
            return Math.abs(click.x - first.x) < 40 && Math.abs(click.y - first.y) < 40;
          });
          if (clustered) {
            sendEvent(base, "rage_click", payload);
            recentClicks = [];
          }
        }
      },
      true
    );

    document.addEventListener(
      "touchstart",
      function (e) {
        var touch = e.touches && e.touches[0];
        if (!touch) return;
        lastTouchAt = Date.now();
        var target = e.target && e.target.closest ? e.target.closest('a,button,input,select,textarea,summary,[role="button"],[data-track-click]') : null;
        var proxyEvent = { clientX: touch.clientX, clientY: touch.clientY };
        var payload = getTargetPayload(target || e.target, proxyEvent, "touch");
        if (isMeaningfulTarget(e.target)) {
          sendEvent(base, "interaction_touch", payload);
        }
      },
      { capture: true, passive: true }
    );
  }

  function installScrollTracking(base) {
    var milestones = [25, 50, 75, 90, 100];
    var sent = {};
    var ticking = false;

    function checkScroll() {
      ticking = false;
      var doc = document.documentElement;
      var body = document.body;
      var scrollTop = window.scrollY || doc.scrollTop || body.scrollTop || 0;
      var scrollHeight = Math.max(body.scrollHeight, doc.scrollHeight, body.offsetHeight, doc.offsetHeight);
      var viewport = window.innerHeight || doc.clientHeight || 0;
      var maxScroll = Math.max(scrollHeight - viewport, 1);
      var depth = Math.min(100, Math.round(((scrollTop + viewport) / Math.max(scrollHeight, viewport, 1)) * 100));
      var progress = Math.min(100, Math.round((scrollTop / maxScroll) * 100));

      milestones.forEach(function (milestone) {
        if (sent[milestone] || depth < milestone) return;
        sent[milestone] = true;
        sendEvent(base, "scroll_depth_" + milestone, {
          interaction_type: "scroll",
          scroll_depth_pct: milestone,
          scroll_progress_pct: progress,
          viewport_height: viewport,
          page_height: scrollHeight,
        });
      });
    }

    window.addEventListener(
      "scroll",
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(checkScroll);
      },
      { passive: true }
    );
    checkScroll();
  }

  function boot() {
    var cfg = safeParseConfig();
    if (!cfg) return;
    var collectorEnabled = !!(cfg.enabled && cfg.endpoint);
    var clarityEnabled = !!cfg.clarityEnabled;

    var base = {
      endpoint: cfg.endpoint,
      collectorEnabled: collectorEnabled,
      clarityEnabled: clarityEnabled,
      pageType: cfg.pageType || "",
      pageProductId: cfg.productId || "",
      customerId: cfg.customerId || "",
      shop: cfg.shop || "",
      sessionId: getSessionId(),
    };

    // Product page view event.
    if (base.pageType === "product" && base.pageProductId) {
      sendEvent(base, "product_view", { product_id: base.pageProductId });
    }

    // Add to cart events from product forms.
    document.addEventListener(
      "submit",
      function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

        var productRoot = form.closest("product-info,[data-product-id]");
        var productId = productRoot ? productRoot.getAttribute("data-product-id") : base.pageProductId;
        var variantField = form.querySelector('input[name="id"], select[name="id"]');
        var variantId = variantField ? variantField.value : "";
        sendEvent(base, "add_to_cart", { product_id: productId, variant_id: variantId });
      },
      true
    );

    // Begin checkout from cart buttons / links.
    document.addEventListener(
      "click",
      function (e) {
        var el = e.target && e.target.closest ? e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]') : null;
        if (!el) return;
        if (el.getAttribute("data-session-checkout-tracked") === "1") return;
        el.setAttribute("data-session-checkout-tracked", "1");
        e.preventDefault();
        e.stopImmediatePropagation();
        sendBeginCheckoutEvents(base).finally(function () {
          continueCheckout(el);
        });
      },
      true
    );

    // Track high-intent product CTA clicks on non-product pages.
    document.addEventListener(
      "click",
      function (e) {
        var link = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
        if (!link) return;
        var payload = getTargetPayload(link, e, "click");
        payload.product_handle = getProductHandleFromHref(payload.target_href);
        sendEvent(base, "product_cta_click", payload);
      },
      true
    );

    installInteractionTracking(base);
    installScrollTracking(base);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
